import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Radar } from "lucide-react";
import { useTr } from "@/i18n/translator";

export default function Competitors() {
  const tr = useTr();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", url: "", network: "instagram" });

  const load = () => api.get("/competitors").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.url) return toast.error(tr("Completa los datos"));
    try {
      await api.post("/competitors", form);
      setForm({ name: "", url: "", network: "instagram" });
      toast.success("Competidor agregado");
      load();
    } catch {
      toast.error("Error");
    }
  };
  const remove = async (id) => { await api.delete(`/competitors/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="competitors-page">
      <div>
        <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("RECONOCIMIENTO · COMPETENCIA")}</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2">{tr("Monitor de competidores")}</h1>
      </div>

      <div className="bg-white border border-[#0A0A0A] p-6">
        <div className="grid md:grid-cols-4 gap-3 items-end">
          <label className="block md:col-span-1">
            <span className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("NOMBRE")}</span>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 w-full bg-white border border-[#0A0A0A] px-4 py-3 font-mono-data text-sm" data-testid="comp-name" />
          </label>
          <label className="block md:col-span-2">
            <span className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("URL / HANDLE")}</span>
            <input value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className="mt-2 w-full bg-white border border-[#0A0A0A] px-4 py-3 font-mono-data text-sm" placeholder="https://instagram.com/…" data-testid="comp-url" />
          </label>
          <label className="block">
            <span className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("RED")}</span>
            <select value={form.network} onChange={(e) => setForm({ ...form, network: e.target.value })} className="mt-2 w-full bg-white border border-[#0A0A0A] px-4 py-3 font-mono-data text-sm" data-testid="comp-network">
              <option value="twitter">Twitter / X</option>
              <option value="facebook">Facebook</option>
              <option value="instagram">Instagram</option>
              <option value="linkedin">LinkedIn</option>
              <option value="tiktok">TikTok</option>
            </select>
          </label>
        </div>
        <button onClick={add} className="mt-4 bg-[#0A0A0A] text-white px-4 py-3 font-mono-mark text-xs hover-brutal border border-[#0A0A0A] flex items-center gap-2" data-testid="comp-add">
          <Plus className="w-4 h-4" /> {tr("AGREGAR COMPETIDOR")}
        </button>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-dashed border-[#0A0A0A] p-10 text-center">
          <Radar className="w-8 h-8 mx-auto text-[#5C5C5C]" />
          <div className="font-mono-mark text-[10px] text-[#5C5C5C] mt-3">{tr("SIN OBJETIVOS")}</div>
          <div className="text-sm mt-1">{tr("Agrega competidores para monitorearlos.")}</div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c) => (
            <div key={c.id} className="bg-white border border-[#0A0A0A] p-5" data-testid={`comp-card-${c.id}`}>
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-display text-xl">{c.name}</div>
                  <div className="font-mono-mark text-[10px] text-[#E53935]">{c.network.toUpperCase()}</div>
                </div>
                <button onClick={() => remove(c.id)} className="text-[#5C5C5C] hover:text-[#E53935]" data-testid={`comp-delete-${c.id}`}>
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              <div className="grid grid-cols-2 gap-3 border-t border-[#0A0A0A] pt-3">
                <div>
                  <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("SEGUIDORES")}</div>
                  <div className="font-display text-2xl font-mono-data">{c.followers.toLocaleString()}</div>
                </div>
                <div>
                  <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("ENGAGEMENT")}</div>
                  <div className="font-display text-2xl font-mono-data">{c.engagement_rate}%</div>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-[#0A0A0A]">
                <div className="font-mono-mark text-[10px] text-[#5C5C5C] mb-2">{tr("LO QUE LES FUNCIONA")}</div>
                <div className="flex flex-wrap gap-1">
                  {c.top_content_types.map((t) => (
                    <span key={t} className="font-mono-mark text-[9px] px-2 py-1 bg-[#FFD600]">{t.toUpperCase()}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
